import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { deleteFileApi, uploadApi } from "./uploadAPI";

export const upload = createAsyncThunk(
  "file/upload",
  async ({ type, body }, { rejectWithValue }) => {
    try {
      return await uploadApi(type, body);
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to init upload");
    }
  },
);

export const deleteFile = createAsyncThunk(
  "file/delete-file",
  async ({ fileId, type }, { rejectWithValue }) => {
    try {
      return await deleteFileApi(fileId, type);
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to delete file");
    }
  },
);

const uploadSlice = createSlice({
  name: "uploads",
  initialState: {
    upload: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(upload.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(upload.fulfilled, (state, action) => {
        state.upload = action.payload;
        state.loading = false;
      })
      .addCase(upload.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteFile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteFile.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteFile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default uploadSlice.reducer;
